import { Id } from "./id";
import { BasicProfile } from "./profile";

export enum KPIStatus {
  OnTarget = "on_target",
  ApprovalGranted = "approval_granted",
  ApprovalRequested = "approval_requested",
  ApprovalRejected = "approval_rejected",
  ApprovalRequired = "approval_required"
}

export enum KPIUnit {
  Percentage = "percentage",
  Hours = "hours"
}

export enum KPIThresholdType {
  Range = "range",
  Deviation = "deviation"
}

export type KPI = {
  id: Id;
  name: string;
  unit: KPIUnit;
  createdAt: string;
  updatedAt: string;
};

export type KPIResult = {
  id: Id;
  engagementId: number;
  indicatorId: number;
  status: KPIStatus;
  value: number;
  threshold?: {
    id: Id;
    minValue: number | null;
    maxValue: number | null;
    deviationPercentage: number | null;
    thresholdType: KPIThresholdType;
  };
  createdAt: string;
};

export type KPIEvent = {
  id: Id;
  engagementId: Id;
  indicatorId: Id;
  profile: BasicProfile | null;
  status: KPIStatus | null;
  value: number | null;
  comment: string | null;
  createdAt: string;
};

export type KpiFilterValue = {
  id: Id;
  value: string;
};

export type KpiFilter = {
  id: Id;
  name: string;
  values: KpiFilterValue[];
};

export type KpiFilterGroup = {
  id: number;
  name: string;
  filters: KpiFilter[];
  customType: {
    id: Id;
    name: string;
  };
  statistics: {
    indicatorsCount: number;
  };
};

export type DetailedKpiFilterGroup = KpiFilterGroup & {
  indicators: KpiIndicator[];
};

export type KpiThreshold = {
  id: Id;
  customValue: {
    id: Id;
    value: string;
  };
  minValue: number | null;
  maxValue: number | null;
  deviationPercentage: number | null;
  thresholdType: KPIThresholdType;
};

export type KpiThresholdWithUnit = KpiThreshold & {
  unit: KPIUnit;
};

export type KpiIndicator = {
  id: Id;
  name: string;
  unit: KPIUnit;
  thresholds: KpiThreshold[];
};

export type KpiIndicatorTableData = KpiIndicator & {
  childrenTableData: KpiThresholdWithUnit[];
};
